import { render, staticRenderFns } from "./Token.m.vue?vue&type=template&id=01a964b6&scoped=true"
import script from "./Token.m.vue?vue&type=script&lang=js"
export * from "./Token.m.vue?vue&type=script&lang=js"
import style0 from "./Token.m.vue?vue&type=style&index=0&id=01a964b6&prod&lang=scss&scoped=true"
import style1 from "./Token.m.vue?vue&type=style&index=1&id=01a964b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a964b6",
  null
  
)

export default component.exports